// extracted by mini-css-extract-plugin
export default {"modal":"gR31s_modal"};